import { BotDisplayType, BotInfo } from '_c/typings/proto';
import BotApi from '_c/business/api/bot';
import { logger } from '_c/util/logger';
import { useToast } from '@/component/kk-toast';

const env = import.meta.env.VITE_BUILD_ENV;
export class BotPageHandle {
  /** 单例 */
  private static instance: BotPageHandle;
  public static getInstance(): BotPageHandle {
    if (!BotPageHandle.instance) {
      BotPageHandle.instance = new BotPageHandle();
    }
    return BotPageHandle.instance;
  }
  private tag = 'BotPageHandle';
  private requestBotDetailLock = false;

  public openConfig(gid: string, botId: string, botInfo?: BotInfo, params?: Map<string, unknown>): void {
    const botInfoId = botInfo?.id;
    if (botInfoId && Number(botInfoId) > 0) {
      this.openConfigWithBotId(botInfoId, gid, params);
    } else if (botId !== null) {
      this.openConfigWithBotId(botId, gid, params);
    } else {
      this.showErrorToastInfo();
    }
  }

  public openH5(gid: string, url: string, botId: string, botInfo?: BotInfo, params?: Map<string, unknown>): void {
    //  正式环境 AppEnvironmentMgr.singleton.envType == 0 &&
    if (env !== 'test') {
      if (url.indexOf('https') !== 0) {
        this.showErrorToastInfo('不支持的消息类型');
        return;
      }
    }

    if (botInfo && Number(botInfo.id) > 0) {
      this.openH5WithBotId(botInfo.id, gid, url, params);
    } else if (botId) {
      this.openH5WithBotId(botId, gid, url, params);
    } else {
      this.showErrorToastInfo();
    }
  }
  private openConfigWithBotId(botId: string, gid: string, params?: Map<string, unknown>): void {
    if (this.requestBotDetailLock) return;
    this.requestBotDetailLock = true;
    BotApi.getBotDetail(botId, gid)
      .then((botInfoDetailRsp) => {
        const { sig, botInfo } = botInfoDetailRsp;
        if (sig !== '') {
          this.openConfigWithBotInfo(botInfo, sig, gid, params);
        } else {
          this.showErrorToastInfo();
        }
      })
      .catch((e) => {
        logger.info(this.tag, `get botInfo error, ${e.toString()}`);
        this.showErrorToastInfo();
      })
      .finally(() => {
        this.requestBotDetailLock = false;
      });
  }
  private openH5WithBotId(botId: string, gid: string, url = '', params?: Map<string, unknown>): void {
    if (this.requestBotDetailLock) return;
    this.requestBotDetailLock = true;
    BotApi.getBotDetail(botId, gid)
      .then((botInfoDetailRsp) => {
        const { sig, botInfo } = botInfoDetailRsp;
        if (sig !== '') {
          this.openH5WithBotInfo(botInfo, sig, gid, url, params);
        } else {
          this.showErrorToastInfo();
        }
      })
      .catch((e) => {
        logger.info(this.tag, `get botInfo error, ${e.toString()}`);
        this.showErrorToastInfo();
      })
      .finally(() => {
        this.requestBotDetailLock = false;
      });
  }
  private showErrorToastInfo(str?: string): void {
    const { error } = useToast();
    if (!str) {
      error('打开失败，请检查机器人设置!');
      return;
    }
    error(str);
  }

  private openConfigWithBotInfo(botInfo: BotInfo, sig: string, gid: string, params?: Map<string, unknown>): void {
    const type = botInfo.displayConfig?.type;
    if (type === BotDisplayType.DisplayTypeH5) {
      const url = botInfo.displayConfig?.h5Config?.h5Url;
      if (url !== '') {
        this.openH5WithBotInfo(botInfo, sig, gid, url, params);
        return;
      }
      // 未知配置
      logger.info(this.tag, 'h5 config error: ${botInfo.botDisplayConfig?.h5Config.toString()}');
    } else if (type === BotDisplayType.DisplayTypeVoltron) {
      this.showErrorToastInfo('暂不支持该类型跳转');
      return;
    }
    // 未知配置
    logger.info(this.tag, `bot display type error: ${botInfo.displayConfig?.type}`);
    this.showErrorToastInfo();
  }

  private openH5WithBotInfo(
    botInfo: BotInfo,
    sig: string,
    gid: string,
    url: string,
    params?: Map<string, unknown>,
  ): void {
    const tempUrl = new URL(url);
    tempUrl.searchParams.set('_gcwv', '8');
    tempUrl.searchParams.set('sig', sig);
    if (params !== null) {
      const paramsJson = JSON.stringify(params);
      tempUrl.searchParams.set('urlParams', paramsJson);
    }
    const res = window.open(tempUrl.toString());
    if (!res) {
      window.alert('T^T 窗口被浏览器拦截了～\r\n请手动点击【网址栏最右边-小窗口图标】打开新窗口');
    }
  }
}
